<template>
  <page :title="title" :breadcrumb="breadcrumb">
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <v-btn text color="secondary" v-on="on">
            More Links...
            <v-icon right>mdi-link</v-icon>
          </v-btn>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <!-- <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 md3>
          <v-navigation-drawer permanent light width="400px" class="mavSmallMenu">
            <v-toolbar flat>
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="title">
                      {{ glapplnInt | glapplnIntDesc }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-toolbar>
            <v-list class="pt-0">
              <v-divider></v-divider>
              <v-list-item v-for="(item) in sideMenu" :key="item.name" :to="{ name: item.name, params: item.params }">
                <v-list-item-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 md9>
          <transition name="slide-x-transition" mode="out-in">
            <router-view></router-view>
          </transition>
        </v-flex>
      </v-layout>
    </v-container> -->
    <v-card>
      <v-toolbar>
        <v-toolbar-title>{{ glapplnInt | glapplnIntDesc }}</v-toolbar-title>
      </v-toolbar>
      <transition name="slide-x-transition" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-card>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { glAppInterface } from '@/const/acct/glAcct'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
export default {
  data() {
    return {
      title: 'Query GL Mapping and Interface',
      breadcrumb: [],
      sideMenu: [
        { name: 'qMapFactor', text: 'Map Factor' },
        { name: 'qGlInterface', text: 'GL Interface' }
      ],
      sideFunction: [
        {
          text: 'Map Factor',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'qMapFactor' }
        },
        {
          text: 'GL Interface',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'qGlInterface' }
        }
      ],
      glapplnIntDesc: null
    }
  },
  created() {
    const jsonData = JSON.parse(sessionStorage.getItem('glMapping'))
    if (jsonData) {
      this.$store.commit('GLMAPPING_COMMIT_KEY', jsonData)
    }
    this.breadcrumb = this.derieveBreadcrumbByName('glMapping')
    this.breadcrumb.push({
      text: this.title
    })
  },
  beforeRouteLeave(to, from, next) {
    sessionStorage.removeItem('glMapping')
    next()
  },
  computed: {
    ...mapGetters(['derieveBreadcrumbByName']),
    menu() {
      return this.$store.state.glAcctParam.menu
    }
  },
  filters: {
    glapplnIntDesc(value) {
      return value + ' - ' + glAppInterface[value]
    }
  },
  watch: {
    glapplnInt(newVal, oldVal) {
      if (oldVal === 'new') {
        this.doInit()
      }
    }
  },
  components: {
    SideFunctionMenu
  },
  props: ['glapplnInt']
}
</script>

<style lang="scss">
.queryPnl {
  margin-top: 50px;
}
.smallMenu {
  width: 400px;
}
</style>
